import { Injectable } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { Observable } from 'rxjs';
import { CallableFunction } from '../../resources/app-firebase';
import { CommonIdFindUniversitiesRequest } from 'src/app/models/common-id/common-id-find-universities-request';
import { CommonIdFindUniversitiesResponse } from 'src/app/models/common-id/common-id-find-universities-response';

@Injectable({
  providedIn: 'root'
})
export class CommonIdFindUniversitiesService {
  constructor(private aff: AngularFireFunctions) {}

  commonIdFindUniversities(request: CommonIdFindUniversitiesRequest): Observable<CommonIdFindUniversitiesResponse[]> {
    const callable = this.aff.httpsCallable(CallableFunction.COMMON_ID_FIND_UNIVERSITIES);
    return callable(request);
  }
}
